import { render, staticRenderFns } from "./PartRequestList.vue?vue&type=template&id=dd3d26e2"
import script from "./PartRequestList.vue?vue&type=script&lang=ts"
export * from "./PartRequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports